
import Vue from 'vue';
import Vuex from 'vuex';
import {
    CollapsePlugin,
    AlertPlugin,
    PopoverPlugin,
    FormRadioPlugin,
    FormCheckboxPlugin,
    PaginationPlugin,
    TabsPlugin,
    ModalPlugin,
    BNavItemDropdown,
    BFormFile,
    BDropdown,
    BDropdownItem,
    BDropdownDivider, CarouselPlugin,
} from 'bootstrap-vue';

import { VueMasonryPlugin } from 'vue-masonry/dist/vue-masonry-plugin-umd';
import VueSocialSharing from 'vue-social-sharing';
import VueRemoteModal from './plugins/vue-remote-modal';
import ElLoading from 'element-loading';
import Formoj from 'formoj';

import 'bootstrap-vue/dist/bootstrap-vue.min.css';

import store from './store';

import components from "./components";
import * as directives from "./directives";

import focus from './util/focus';
import Cursus from "acacia/packages/cursus/src/index.js";
import CursusComponent from "acacia/packages/cursus/src/component.js";

Vue.use(Vuex);

Vue.use(CarouselPlugin);
Vue.use(CollapsePlugin);
Vue.use(AlertPlugin);
Vue.use(PopoverPlugin);
Vue.use(FormRadioPlugin);
Vue.use(FormCheckboxPlugin);
Vue.use(PaginationPlugin);
Vue.use(TabsPlugin);
Vue.use(ModalPlugin);
Vue.component('b-dropdown', BDropdown);
Vue.component('b-dropdown-divider', BDropdownDivider);
Vue.component('b-dropdown-item', BDropdownItem);
Vue.component('b-form-file', BFormFile);
Vue.component('b-nav-item-dropdown', BNavItemDropdown);

Vue.use(Cursus, {
    baseUrl: document.head.querySelector('meta[name="acacia_url"]')?.content,
});
Vue.component('cursus', CursusComponent);

Vue.use(VueMasonryPlugin);
Vue.use(VueSocialSharing);
Vue.use(VueRemoteModal);

Vue.use(ElLoading);
Vue.use(Formoj, {
    scrollOffset: 160, // offset the height of header
    apiBaseUrl: document.head.querySelector('meta[name=formoj_api_url]')?.content
        || '/formoj/api',
});

Object.keys(components).forEach((name) => {
    Vue.component(name, components[name]);
});

document.querySelectorAll('[data-vue]').forEach(el => {
    const app = new Vue({
        directives: {
            ...directives,
        },

        store: new Vuex.Store(store),

        methods: {
            focus,
        },
    });

    app.$mount(el);
});
